// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/home/education-header-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/images/home/operations-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/images/home/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/images/home/education-header-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-content .modernize-staff-education {
  display: flex;
  margin-top: 22px;
  height: 530px;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-radius: 20px;
}
.home-page-content .modernize-staff-education .modernize-left {
  width: 43%;
  height: 100%;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 100px 0 100px 100px;
  color: #fff;
}
.home-page-content .modernize-staff-education .modernize-left .modernize-title {
  font-size: 56px;
  font-weight: 600;
  line-height: 120%;
}
.home-page-content .modernize-staff-education .modernize-left .modernize-title .blue-part {
  color: #a5c7ff;
}
.home-page-content .modernize-staff-education .modernize-left .modernize-subtitle {
  font-size: 22px;
  line-height: 180%;
  margin-top: 24px;
}
.home-page-content .modernize-staff-education .modernize-left .request-demo-btn {
  margin-top: 46px;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid #dee1e7;
  border-radius: 8px;
  padding: 12px 24px 12px 24px;
  gap: 8px;
  display: flex;
  align-items: center;
  width: 200px;
  height: 46px;
  color: #448aff;
  font-weight: 600;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
}
.home-page-content .modernize-staff-education .modernize-right {
  height: 100%;
  position: relative;
  width: 57%;
}
.home-page-content .modernize-staff-education .modernize-right .modernize-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.home-page-content .modernize-staff-education .modernize-right::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #3571d6 0%, rgba(53, 113, 214, 0) 39.9%);
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  pointer-events: none;
}
.home-page-content .manual-process {
  padding: 120px 100px;
  display: flex;
}
.home-page-content .manual-process .manual-process-left-block {
  padding: 80px 32px 80px 0;
  width: 44%;
  display: flex;
  align-items: center;
}
.home-page-content .manual-process .manual-process-left-block .say-goodbye-title {
  color: #448aff;
  font-weight: 400;
  font-size: 40px;
  line-height: 120%;
}
.home-page-content .manual-process .manual-process-left-block .say-goodbye-subtitle {
  margin-top: 20px;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
}
.home-page-content .manual-process .manual-process-right-block {
  width: 56%;
}
.home-page-content .manual-process .manual-process-right-block .manual-process-list {
  width: 100%;
}
.home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item {
  min-height: 60px;
  padding: 12px 24px;
  border-left: 2px solid #a5c7ff;
  background: linear-gradient(90deg, #e7f0ff 0%, #ffffff 100%);
  margin-top: 12px;
  font-size: 20px;
  font-weight: 600;
  line-height: 180%;
  color: #040e46;
}
.home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(1) {
  margin-top: 0;
}
.home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(2) {
  margin-right: 68px;
  margin-left: 30px;
}
.home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(3) {
  margin-right: 38px;
  margin-left: 60px;
}
.home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(4) {
  margin-right: 8px;
  margin-left: 90px;
}
.home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(5) {
  margin-right: -22px;
  margin-left: 120px;
}
.home-page-content .core-capabilities {
  padding: 80px;
  background-color: #e7f0ff;
  border: 1px solid #eceef1;
  border-radius: 20px;
}
.home-page-content .core-capabilities .core-capabilities-title {
  font-size: 40px;
  line-height: 120%;
  color: #3571d6;
  text-align: center;
}
.home-page-content .core-capabilities .core-capabilities-grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-top: 46px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item {
  position: relative;
  height: 230px;
  padding: 112px 36px 36px 36px;
  background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)), radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-tall {
  grid-row: span 2;
  height: 492px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper svg {
  position: absolute;
  top: 42px;
  right: 42px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-screenshot-img {
  width: 100%;
  height: 260px;
  background-size: cover;
  position: relative;
  z-index: 2;
  object-fit: cover;
  border-radius: 4px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content {
  position: relative;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-title {
  color: #040e46;
  font-size: 26px;
  font-weight: 600;
  line-height: 130%;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-subtitle {
  margin-top: 12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(1) {
  padding: 6px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(1) .corner-image-wrapper {
  top: 215px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(1) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) {
  padding: 6px;
  display: flex;
  gap: 32px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-screenshot-wrapper {
  width: calc(50% - 16px);
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-right-block {
  width: calc(50% - 16px);
}
.home-page-content .education-see-in-action {
  background-color: #3571d6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  padding: 60px;
  border-radius: 20px;
  background-size: cover;
  margin-top: 20px;
  padding: 100px 100px 120px 100px;
}
.home-page-content .education-see-in-action .see-in-action-title {
  font-size: 40px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper {
  display: flex;
  gap: 32px;
  margin-top: 80px;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper {
  flex: 1 1;
  max-width: 276px;
  position: relative;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper .see-in-action-img {
  width: 100%;
  height: 100%;
  max-height: 276px;
  object-fit: cover;
  border-radius: 10px;
  object-position: center;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper .scale-icon {
  position: absolute;
  bottom: -41px;
  right: -22px;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper:nth-child(1) .see-in-action-img {
  object-position: 0px -85px;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper:nth-child(2) .see-in-action-img {
  object-position: 0px -60px;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper:nth-child(3) .see-in-action-img {
  object-position: bottom;
}
.home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper:nth-child(4) .see-in-action-img {
  object-position: left;
}
.home-page-content .education-reviews-block {
  padding: 60px 100px;
  margin-top: 20px;
}
.home-page-content .education-reviews-block .education-reviews-texts-wrapper {
  display: flex;
}
.home-page-content .education-reviews-block .education-reviews-texts-wrapper .review-block-item {
  padding: 6px 40px;
  flex: 1 1;
}
.home-page-content .education-reviews-block .education-reviews-texts-wrapper .review-block-item:nth-child(1) {
  padding-right: 80px;
  border-right: 1px solid #dee1e7;
}
.home-page-content .education-reviews-block .education-reviews-texts-wrapper .review-block-item:nth-child(2) {
  padding-left: 80px;
}
.home-page-content .education-reviews-block .education-reviews-texts-wrapper .review-block-item .review-text-wrapper {
  font-size: 28px;
  font-weight: 400;
  line-height: 130%;
  min-height: 260px;
}
.home-page-content .education-reviews-block .education-reviews-texts-wrapper .review-block-item .review-text-wrapper .blue-part {
  color: #3571d6;
}
.home-page-content .education-reviews-block .reviewers-wrapper {
  display: flex;
}
.home-page-content .education-reviews-block .reviewers-wrapper .reviewer-wrapper {
  padding-top: 36px;
  display: flex;
  gap: 28px;
  flex: 1 1;
}
.home-page-content .education-reviews-block .reviewers-wrapper .reviewer-wrapper:nth-child(1) {
  padding-left: 40px;
  padding-right: 40px;
  border-right: 1px solid #dee1e7;
}
.home-page-content .education-reviews-block .reviewers-wrapper .reviewer-wrapper:nth-child(2) {
  padding-left: 80px;
}
.home-page-content .education-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-avatar-wrapper img {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  object-fit: cover;
}
.home-page-content .education-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-name-wrapper {
  padding: 17px 0;
}
.home-page-content .education-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-name-wrapper .reviewer-name {
  font-size: 24px;
  font-weight: 600;
  line-height: 150%;
}
.home-page-content .education-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-name-wrapper .reviewer-position {
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}
.home-page-content .education-core-benefits {
  padding: 135px 100px 80px 100px;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid #eceef1;
  margin-top: 20px;
}
.home-page-content .education-core-benefits::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.35;
  z-index: 0;
  border-radius: 20px;
  mix-blend-mode: luminosity;
}
.home-page-content .education-core-benefits .education-core-benefits-title {
  color: #000;
  font-size: 40px;
  text-align: center;
}
.home-page-content .education-core-benefits .education-core-benefits-slider {
  margin-top: 80px;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .swiper {
  padding-bottom: 3rem;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .swiper .swiper-button-next,
.home-page-content .education-core-benefits .education-core-benefits-slider .swiper .swiper-button-prev {
  display: none;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .swiper .swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  opacity: 1;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .swiper .swiper-pagination-bullet-active {
  background: #4b6fff;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .custom-nav {
  display: flex;
  justify-content: space-between;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .custom-nav button {
  position: relative;
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  color: #3571d6;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .custom-nav button:hover {
  background-color: #f5f5f5;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .education-core-benefits-slide {
  position: relative;
  border-radius: 1rem;
  text-align: center;
  height: 270px;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .education-core-benefits-slide .education-core-benefits-slide-content {
  background-color: #fff;
  border-radius: 10px;
  height: 240px;
  padding: 80px 28px;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .education-core-benefits-slide .education-core-benefits-slide-content .education-core-benefits-title {
  color: #3571d6;
  font-size: 28px;
  font-weight: 600;
  line-height: 130%;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .education-core-benefits-slide .education-core-benefits-slide-content .education-core-benefits-subtitle {
  color: #445169;
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
  margin-top: 12px;
}
.home-page-content .education-core-benefits .education-core-benefits-slider .education-core-benefits-slide .icon-wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 90px;
  width: 90px;
  background-color: #3571d6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.education-page.isMobile .home-page-content .modernize-staff-education {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  margin-top: 37px;
  height: unset;
}
.education-page.isMobile .home-page-content .modernize-staff-education .modernize-left {
  padding: 0 20px 20px 20px;
  margin-top: 240px;
  width: 100%;
}
.education-page.isMobile .home-page-content .modernize-staff-education .modernize-left .modernize-title {
  font-size: 32px;
}
.education-page.isMobile .home-page-content .modernize-staff-education .modernize-left .modernize-subtitle {
  font-size: 20px;
  line-height: 160%;
  margin-top: 16px;
}
.education-page.isMobile .home-page-content .modernize-staff-education .modernize-left .request-demo-btn {
  margin-top: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 150%;
}
.education-page.isMobile .home-page-content .manual-process {
  padding: 40px 20px 40px 20px;
  display: block;
}
.education-page.isMobile .home-page-content .manual-process .manual-process-left-block {
  width: 100%;
  padding: 0;
}
.education-page.isMobile .home-page-content .manual-process .manual-process-left-block .say-goodbye-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
}
.education-page.isMobile .home-page-content .manual-process .manual-process-right-block {
  margin-top: 18px;
  width: 100%;
}
.education-page.isMobile .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item {
  font-weight: 600;
  font-size: 18px;
  line-height: 120%;
  min-height: unset;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 10px !important;
}
.education-page.isMobile .home-page-content .core-capabilities {
  padding: 40px 20px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-title {
  font-size: 32px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper {
  margin-top: 46px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col {
  padding: 6px;
  display: flex;
  gap: 8px;
  position: relative;
  background: radial-gradient(100% 157.58% at 0% 100%, rgba(68, 138, 255, 0.1) 0%, rgba(68, 138, 255, 0) 50%), linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb));
  border: 1px solid #fff;
  border-radius: 10px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .core-capabilities-item-screenshot-wrapper .core-capabilities-item-screenshot-img {
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #fff;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  width: 130px;
  height: 132px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .corner-image-wrapper {
  width: 100%;
  position: absolute;
  top: -6px;
  right: -6px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .corner-image-wrapper .corner-image {
  width: 100%;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .core-capabilities-item-content {
  flex-grow: 1;
  position: relative;
  padding: 74px 12px 12px 12px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .core-capabilities-item-content .core-capabilities-item-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 130%;
  color: #040e46;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-2 {
  margin-top: 18px;
  display: flex;
  gap: 18px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-2 .core-capabilities-col {
  width: 50%;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-2 .core-capabilities-col .core-capabilities-item-content {
  padding-top: 48px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-3 {
  margin-top: 18px;
  display: flex;
  gap: 18px;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-3 .core-capabilities-col {
  width: 50%;
}
.education-page.isMobile .home-page-content .core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-3 .core-capabilities-col .core-capabilities-item-content {
  padding-top: 48px;
}
.education-page.isMobile .home-page-content .education-see-in-action {
  margin-top: 10px;
  padding: 40px 20px 20px 20px;
}
.education-page.isMobile .home-page-content .education-see-in-action .see-in-action-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
}
.education-page.isMobile .home-page-content .education-see-in-action .see-in-action-images-wrapper {
  flex-wrap: wrap;
  margin-top: 36px;
  justify-content: center;
}
.education-page.isMobile .home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper {
  flex-basis: 100%;
}
.education-page.isMobile .home-page-content .education-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper .see-in-action-img {
  width: 276px;
  height: 276px;
}
.education-page.isMobile .home-page-content .education-core-benefits {
  margin-top: 10px;
  padding: 40px 20px 20px 20px;
}
.education-page.isMobile .home-page-content .education-core-benefits .education-core-benefits-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/subpages/Education/styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,yDAAA;EACA,mBAAA;AAAJ;AAEI;EACE,UAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,WAAA;AAAN;AAEM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAAR;AAEQ;EACE,cAAA;AAAV;AAIM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAFR;AAKM;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,4BAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,4DAAA;EACA,6DAAA;AAHR;AAOI;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AALN;AAOM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,gCAAA;AALR;AAQM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,2EAAA;EACA,6BAAA;EACA,gCAAA;EACA,oBAAA;AANR;AAWE;EACE,oBAAA;EACA,aAAA;AATJ;AAWI;EACE,yBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AATN;AAWM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AATR;AAYM;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVR;AAcI;EACE,UAAA;AAZN;AAcM;EACE,WAAA;AAZR;AAcQ;EACE,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,4DAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAZV;AAcU;EACE,aAAA;AAZZ;AAeU;EACE,kBAAA;EACA,iBAAA;AAbZ;AAgBU;EACE,kBAAA;EACA,iBAAA;AAdZ;AAiBU;EACE,iBAAA;EACA,iBAAA;AAfZ;AAkBU;EACE,mBAAA;EACA,kBAAA;AAhBZ;AAuBE;EACE,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AArBJ;AAuBI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AArBN;AAwBI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;AAtBN;AAwBM;EACE,kBAAA;EACA,aAAA;EACA,6BAAA;EAEA,wMAAA;AAvBR;AA0BQ;EACE,gBAAA;EACA,aAAA;AAxBV;AA2BQ;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;AAzBV;AA2BU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAzBZ;AA6BQ;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AA3BV;AA8BQ;EACE,kBAAA;AA5BV;AA8BU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA5BZ;AA+BU;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7BZ;AAiCQ;EACE,YAAA;AA/BV;AAiCU;EACE,UAAA;AA/BZ;AAkCU;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAhCZ;AAoCQ;EACE,YAAA;EACA,aAAA;EACA,SAAA;AAlCV;AAoCU;EACE,uBAAA;AAlCZ;AAqCU;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAnCZ;AAsCU;EACE,uBAAA;AApCZ;AA2CE;EACE,yBAAA;EACA,yDAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;AAzCJ;AA2CI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAzCN;AA4CI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AA1CN;AA4CM;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;AA1CR;AA4CQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AA1CV;AA6CQ;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AA3CV;AA+CU;EACE,0BAAA;AA7CZ;AAkDU;EACE,0BAAA;AAhDZ;AAqDU;EACE,uBAAA;AAnDZ;AAwDU;EACE,qBAAA;AAtDZ;AA6DE;EACE,mBAAA;EACA,gBAAA;AA3DJ;AA6DI;EACE,aAAA;AA3DN;AA6DM;EACE,iBAAA;EACA,SAAA;AA3DR;AA6DQ;EACE,mBAAA;EACA,+BAAA;AA3DV;AA8DQ;EACE,kBAAA;AA5DV;AA+DQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AA7DV;AA+DU;EACE,cAAA;AA7DZ;AAmEI;EACE,aAAA;AAjEN;AAmEM;EACE,iBAAA;EACA,aAAA;EACA,SAAA;EACA,SAAA;AAjER;AAmEQ;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;AAjEV;AAoEQ;EACE,kBAAA;AAlEV;AAsEU;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AApEZ;AAwEQ;EACE,eAAA;AAtEV;AAwEU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAtEZ;AAyEU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAvEZ;AA8EE;EACE,+BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;AA5EJ;AA8EI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AA5EN;AA+EI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AA7EN;AAgFI;EACE,gBAAA;AA9EN;AAgFM;EACE,oBAAA;AA9ER;AAgFQ;;EAEE,aAAA;AA9EV;AAiFQ;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA/EV;AAkFQ;EACE,mBAAA;AAhFV;AAoFM;EACE,aAAA;EACA,8BAAA;AAlFR;AAoFQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAlFV;AAmFU;EACE,yBAAA;AAjFZ;AAsFM;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AApFR;AAsFQ;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AApFV;AAsFU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AApFZ;AAuFU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AArFZ;AAyFQ;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvFV;;AAgGI;EACE,yDAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AA7FN;AA+FM;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AA7FR;AA+FQ;EACE,eAAA;AA7FV;AAgGQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AA9FV;AAiGQ;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AA/FV;AAoGI;EACE,4BAAA;EACA,cAAA;AAlGN;AAoGM;EACE,WAAA;EACA,UAAA;AAlGR;AAoGQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAlGV;AAsGM;EACE,gBAAA;EACA,WAAA;AApGR;AAuGU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AArGZ;AA2GI;EACE,kBAAA;AAzGN;AA2GM;EACE,eAAA;AAzGR;AA4GM;EACE,gBAAA;AA1GR;AA6GU;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,sMAAA;EAGA,sBAAA;EACA,mBAAA;AA7GZ;AAgHc;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4DAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;AA9GhB;AAkHY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAhHd;AAkHc;EACE,WAAA;AAhHhB;AAoHY;EACE,YAAA;EACA,kBAAA;EACA,4BAAA;AAlHd;AAoHc;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlHhB;AAuHU;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AArHZ;AAuHY;EACE,UAAA;AArHd;AAuHc;EACE,iBAAA;AArHhB;AA0HU;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AAxHZ;AA0HY;EACE,UAAA;AAxHd;AA0Hc;EACE,iBAAA;AAxHhB;AAgII;EACE,gBAAA;EACA,4BAAA;AA9HN;AAgIM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA9HR;AAiIM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AA/HR;AAiIQ;EACE,gBAAA;AA/HV;AAiIU;EACE,YAAA;EACA,aAAA;AA/HZ;AAqII;EACE,gBAAA;EACA,4BAAA;AAnIN;AAqIM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAnIR","sourcesContent":[".home-page-content {\n  .modernize-staff-education {\n    display: flex;\n    margin-top: 22px;\n    height: 530px;\n    width: 100%;\n    background-image: url('../../../../assets/images/home/education-header-bg.png');\n    border-radius: 20px;\n\n    .modernize-left {\n      width: 43%;\n      height: 100%;\n      border-top-left-radius: 20px;\n      border-bottom-left-radius: 20px;\n      padding: 100px 0 100px 100px;\n      color: #fff;\n\n      .modernize-title {\n        font-size: 56px;\n        font-weight: 600;\n        line-height: 120%;\n\n        .blue-part {\n          color: #a5c7ff;\n        }\n      }\n\n      .modernize-subtitle {\n        font-size: 22px;\n        line-height: 180%;\n        margin-top: 24px;\n      }\n\n      .request-demo-btn {\n        margin-top: 46px;\n        background-color: #fff;\n        border: none;\n        border-bottom: 2px solid #dee1e7;\n        border-radius: 8px;\n        padding: 12px 24px 12px 24px;\n        gap: 8px;\n        display: flex;\n        align-items: center;\n        width: 200px;\n        height: 46px;\n        color: #448aff;\n        font-weight: 600;\n        box-shadow: 0px 6px 10px -4px #0f17281a;\n        box-shadow: 0px 18px 32px -4px #0f172838;\n      }\n    }\n\n    .modernize-right {\n      height: 100%;\n      position: relative;\n      width: 57%;\n\n      .modernize-image {\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n        border-top-right-radius: 20px;\n        border-bottom-right-radius: 20px;\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        background: linear-gradient(90deg, #3571d6 0%, rgba(53, 113, 214, 0) 39.9%);\n        border-top-right-radius: 20px;\n        border-bottom-right-radius: 20px;\n        pointer-events: none; // allows clicks to pass through\n      }\n    }\n  }\n\n  .manual-process {\n    padding: 120px 100px;\n    display: flex;\n\n    .manual-process-left-block {\n      padding: 80px 32px 80px 0;\n      width: 44%;\n      display: flex;\n      align-items: center;\n\n      .say-goodbye-title {\n        color: #448aff;\n        font-weight: 400;\n        font-size: 40px;\n        line-height: 120%;\n      }\n\n      .say-goodbye-subtitle {\n        margin-top: 20px;\n        font-weight: 400;\n        font-size: 20px;\n        line-height: 180%;\n      }\n    }\n\n    .manual-process-right-block {\n      width: 56%;\n\n      .manual-process-list {\n        width: 100%;\n\n        .manual-process-list-item {\n          min-height: 60px;\n          padding: 12px 24px;\n          border-left: 2px solid #a5c7ff;\n          background: linear-gradient(90deg, #e7f0ff 0%, #ffffff 100%);\n          margin-top: 12px;\n          font-size: 20px;\n          font-weight: 600;\n          line-height: 180%;\n          color: #040e46;\n\n          &:nth-child(1) {\n            margin-top: 0;\n          }\n\n          &:nth-child(2) {\n            margin-right: 68px;\n            margin-left: 30px;\n          }\n\n          &:nth-child(3) {\n            margin-right: 38px;\n            margin-left: 60px;\n          }\n\n          &:nth-child(4) {\n            margin-right: 8px;\n            margin-left: 90px;\n          }\n\n          &:nth-child(5) {\n            margin-right: -22px;\n            margin-left: 120px;\n          }\n        }\n      }\n    }\n  }\n\n  .core-capabilities {\n    padding: 80px;\n    background-color: #e7f0ff;\n    border: 1px solid #eceef1;\n    border-radius: 20px;\n\n    .core-capabilities-title {\n      font-size: 40px;\n      line-height: 120%;\n      color: #3571d6;\n      text-align: center;\n    }\n\n    .core-capabilities-grid-container {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 32px;\n      margin-top: 46px;\n\n      .core-capabilities-item {\n        position: relative;\n        height: 230px;\n        padding: 112px 36px 36px 36px;\n\n        background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)),\n          radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);\n\n        &.core-capabilities-item-tall {\n          grid-row: span 2;\n          height: 492px;\n        }\n\n        .corner-image-wrapper {\n          position: absolute;\n          right: 0;\n          top: 0;\n          text-align: right;\n\n          svg {\n            position: absolute;\n            top: 42px;\n            right: 42px;\n          }\n        }\n\n        .core-capabilities-item-screenshot-img {\n          width: 100%;\n          height: 260px;\n          background-size: cover;\n          position: relative;\n          z-index: 2;\n          object-fit: cover;\n          border-radius: 4px;\n        }\n\n        .core-capabilities-item-content {\n          position: relative;\n\n          .core-capabilities-item-title {\n            color: #040e46;\n            font-size: 26px;\n            font-weight: 600;\n            line-height: 130%;\n          }\n\n          .core-capabilities-item-subtitle {\n            margin-top: 12px;\n            font-weight: 400;\n            font-size: 18px;\n            line-height: 150%;\n          }\n        }\n\n        &:nth-child(1) {\n          padding: 6px;\n\n          .corner-image-wrapper {\n            top: 215px;\n          }\n\n          .core-capabilities-item-content {\n            margin-top: 112px;\n            margin-left: 36px;\n            margin-right: 36px;\n          }\n        }\n\n        &:nth-child(4) {\n          padding: 6px;\n          display: flex;\n          gap: 32px;\n\n          .core-capabilities-item-screenshot-wrapper {\n            width: calc(50% - 16px);\n          }\n\n          .core-capabilities-item-content {\n            margin-top: 112px;\n            margin-left: 36px;\n            margin-right: 36px;\n          }\n\n          .core-capabilities-item-right-block {\n            width: calc(50% - 16px);\n          }\n        }\n      }\n    }\n  }\n\n  .education-see-in-action {\n    background-color: #3571d6;\n    background-image: url('../../../../assets/images/home/operations-bg.svg');\n    padding: 60px;\n    border-radius: 20px;\n    background-size: cover;\n    margin-top: 20px;\n    padding: 100px 100px 120px 100px;\n\n    .see-in-action-title {\n      font-size: 40px;\n      font-weight: 400;\n      color: #fff;\n      text-align: center;\n    }\n\n    .see-in-action-images-wrapper {\n      display: flex;\n      gap: 32px;\n      margin-top: 80px;\n\n      .see-in-action-image-wrapper {\n        flex: 1;\n        max-width: 276px;\n        position: relative;\n\n        .see-in-action-img {\n          width: 100%;\n          height: 100%;\n          max-height: 276px;\n          object-fit: cover;\n          border-radius: 10px;\n          object-position: center;\n        }\n\n        .scale-icon {\n          position: absolute;\n          bottom: -41px;\n          right: -22px;\n        }\n\n        &:nth-child(1) {\n          .see-in-action-img {\n            object-position: 0px -85px;\n          }\n        }\n\n        &:nth-child(2) {\n          .see-in-action-img {\n            object-position: 0px -60px;\n          }\n        }\n\n        &:nth-child(3) {\n          .see-in-action-img {\n            object-position: bottom;\n          }\n        }\n\n        &:nth-child(4) {\n          .see-in-action-img {\n            object-position: left;\n          }\n        }\n      }\n    }\n  }\n\n  .education-reviews-block {\n    padding: 60px 100px;\n    margin-top: 20px;\n\n    .education-reviews-texts-wrapper {\n      display: flex;\n\n      .review-block-item {\n        padding: 6px 40px;\n        flex: 1;\n\n        &:nth-child(1) {\n          padding-right: 80px;\n          border-right: 1px solid #dee1e7;\n        }\n\n        &:nth-child(2) {\n          padding-left: 80px;\n        }\n\n        .review-text-wrapper {\n          font-size: 28px;\n          font-weight: 400;\n          line-height: 130%;\n          min-height: 260px;\n\n          .blue-part {\n            color: #3571d6;\n          }\n        }\n      }\n    }\n\n    .reviewers-wrapper {\n      display: flex;\n\n      .reviewer-wrapper {\n        padding-top: 36px;\n        display: flex;\n        gap: 28px;\n        flex: 1;\n\n        &:nth-child(1) {\n          padding-left: 40px;\n          padding-right: 40px;\n          border-right: 1px solid #dee1e7;\n        }\n\n        &:nth-child(2) {\n          padding-left: 80px;\n        }\n\n        .reviewer-avatar-wrapper {\n          img {\n            height: 100px;\n            width: 100px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n        }\n\n        .reviewer-name-wrapper {\n          padding: 17px 0;\n\n          .reviewer-name {\n            font-size: 24px;\n            font-weight: 600;\n            line-height: 150%;\n          }\n\n          .reviewer-position {\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 150%;\n          }\n        }\n      }\n    }\n  }\n\n  .education-core-benefits {\n    padding: 135px 100px 80px 100px;\n    width: 100%;\n    border-radius: 20px;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n    border: 1px solid #eceef1;\n    margin-top: 20px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-image: url('../../../../assets/images/home/hero-bg.png');\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: center;\n      opacity: 0.35;\n      z-index: 0;\n      border-radius: 20px;\n      mix-blend-mode: luminosity;\n    }\n\n    .education-core-benefits-title {\n      color: #000;\n      font-size: 40px;\n      text-align: center;\n    }\n\n    .education-core-benefits-slider {\n      margin-top: 80px;\n\n      .swiper {\n        padding-bottom: 3rem;\n\n        .swiper-button-next,\n        .swiper-button-prev {\n          display: none;\n        }\n\n        .swiper-pagination-bullet {\n          background: #fff;\n          width: 10px;\n          height: 10px;\n          opacity: 1;\n        }\n\n        .swiper-pagination-bullet-active {\n          background: #4b6fff;\n        }\n      }\n\n      .custom-nav {\n        display: flex;\n        justify-content: space-between;\n\n        button {\n          position: relative;\n          z-index: 10;\n          width: 48px;\n          height: 48px;\n          border-radius: 50%;\n          background-color: #fff;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border: none;\n          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n          cursor: pointer;\n          transition: all 0.2s;\n          color: #3571d6;\n          &:hover {\n            background-color: #f5f5f5;\n          }\n        }\n      }\n\n      .education-core-benefits-slide {\n        position: relative;\n        border-radius: 1rem;\n        text-align: center;\n        height: 270px;\n\n        .education-core-benefits-slide-content {\n          background-color: #fff;\n          border-radius: 10px;\n          height: 240px;\n          padding: 80px 28px;\n\n          .education-core-benefits-title {\n            color: #3571d6;\n            font-size: 28px;\n            font-weight: 600;\n            line-height: 130%;\n          }\n\n          .education-core-benefits-subtitle {\n            color: #445169;\n            font-size: 20px;\n            font-weight: 400;\n            line-height: 150%;\n            margin-top: 12px;\n          }\n        }\n\n        .icon-wrapper {\n          position: absolute;\n          top: 0;\n          left: 50%;\n          transform: translate(-50%, 0);\n          height: 90px;\n          width: 90px;\n          background-color: #3571d6;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}\n\n.education-page.isMobile {\n  .home-page-content {\n    .modernize-staff-education {\n      background-image: url('../../../../assets/images/home/education-header-mobile-bg.png');\n      background-size: cover;\n      margin-top: 37px;\n      height: unset;\n\n      .modernize-left {\n        padding: 0 20px 20px 20px;\n        margin-top: 240px;\n        width: 100%;\n\n        .modernize-title {\n          font-size: 32px;\n        }\n\n        .modernize-subtitle {\n          font-size: 20px;\n          line-height: 160%;\n          margin-top: 16px;\n        }\n\n        .request-demo-btn {\n          margin-top: 28px;\n          width: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 16px;\n          line-height: 150%;\n        }\n      }\n    }\n\n    .manual-process {\n      padding: 40px 20px 40px 20px;\n      display: block;\n\n      .manual-process-left-block {\n        width: 100%;\n        padding: 0;\n\n        .say-goodbye-title {\n          font-weight: 400;\n          font-size: 32px;\n          line-height: 120%;\n        }\n      }\n\n      .manual-process-right-block {\n        margin-top: 18px;\n        width: 100%;\n\n        .manual-process-list {\n          .manual-process-list-item {\n            font-weight: 600;\n            font-size: 18px;\n            line-height: 120%;\n            min-height: unset;\n            margin-left: 0 !important;\n            margin-right: 0 !important;\n            margin-top: 10px !important;\n          }\n        }\n      }\n    }\n\n    .core-capabilities {\n      padding: 40px 20px;\n\n      .core-capabilities-title {\n        font-size: 32px;\n      }\n\n      .core-capabilities-mobile-wrapper {\n        margin-top: 46px;\n\n        .core-capabilities-row {\n          .core-capabilities-col {\n            padding: 6px;\n            display: flex;\n            gap: 8px;\n            position: relative;\n            background: radial-gradient(100% 157.58% at 0% 100%, rgba(68, 138, 255, 0.1) 0%, rgba(68, 138, 255, 0) 50%),\n              linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb));\n\n            border: 1px solid #fff;\n            border-radius: 10px;\n\n            .core-capabilities-item-screenshot-wrapper {\n              .core-capabilities-item-screenshot-img {\n                object-fit: cover;\n                border-radius: 4px;\n                border: 1px solid #fff;\n                box-shadow: 0px 6px 10px -4px #0f17281a;\n                box-shadow: 0px 18px 32px -4px #0f172838;\n                width: 130px;\n                height: 132px;\n              }\n            }\n\n            .corner-image-wrapper {\n              width: 100%;\n              position: absolute;\n              top: -6px;\n              right: -6px;\n\n              .corner-image {\n                width: 100%;\n              }\n            }\n\n            .core-capabilities-item-content {\n              flex-grow: 1;\n              position: relative;\n              padding: 74px 12px 12px 12px;\n\n              .core-capabilities-item-title {\n                font-weight: 600;\n                font-size: 18px;\n                line-height: 130%;\n                color: #040e46;\n              }\n            }\n          }\n\n          &.core-capabilities-row-2 {\n            margin-top: 18px;\n            display: flex;\n            gap: 18px;\n\n            .core-capabilities-col {\n              width: 50%;\n\n              .core-capabilities-item-content {\n                padding-top: 48px;\n              }\n            }\n          }\n\n          &.core-capabilities-row-3 {\n            margin-top: 18px;\n            display: flex;\n            gap: 18px;\n\n            .core-capabilities-col {\n              width: 50%;\n\n              .core-capabilities-item-content {\n                padding-top: 48px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .education-see-in-action {\n      margin-top: 10px;\n      padding: 40px 20px 20px 20px;\n\n      .see-in-action-title {\n        font-weight: 400;\n        font-size: 32px;\n        line-height: 120%;\n        text-align: center;\n      }\n\n      .see-in-action-images-wrapper {\n        flex-wrap: wrap;\n        margin-top: 36px;\n        justify-content: center;\n\n        .see-in-action-image-wrapper {\n          flex-basis: 100%;\n\n          .see-in-action-img {\n            width: 276px;\n            height: 276px;\n          }\n        }\n      }\n    }\n\n    .education-core-benefits {\n      margin-top: 10px;\n      padding: 40px 20px 20px 20px;\n\n      .education-core-benefits-title {\n        font-weight: 400;\n        font-size: 32px;\n        line-height: 120%;\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
